export default __webpack_public_path__ + "static/dimo-3c3e92413441787f4351b152905c7b8c.svg";